import { useRef } from 'react';

/**
 * Doesn't change the value of a variable to undefined.
 * Used to persist the value of a variable while refetching to avoid animating out data.
 * (useSWR will return undefined while refetching)
 */
export function useStickyResult<T>(value: T | undefined): T | undefined {
  const ref = useRef<T | undefined>(undefined);
  if (value !== undefined) {
    ref.current = value;
  }
  return ref.current;
}
